// Barre d'achat collante (snippets/snk-sticky-buy.liquid), mobile : visible quand le bouton principal n'est plus à
// l'écran (IntersectionObserver), suit la variante (prix, taille, épuisé) à chaque snk:pair-change de la colonne, et
// son bouton envoie le formulaire principal : même ajout que le bouton principal, drapeau compris (snk-flag-drawer).
if (!customElements.get('snk-sticky-buy')) {
  customElements.define(
    'snk-sticky-buy',
    class SnkStickyBuy extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.form = document.getElementById(`product-form-${this.sectionId}`);
        this.button = this.querySelector('[data-snk-sticky-submit]');
        if (!this.mainButton || !this.form) return;

        this.button.addEventListener('click', () => {
          if (this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
          this.form.requestSubmit();
        });

        // Visible seulement quand le bouton principal est sorti par le haut (pas quand il est encore à venir)
        this.observer = new IntersectionObserver(
          ([entry]) => {
            const above = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            this.classList.toggle('is-visible', above);
            this.setAttribute('aria-hidden', above ? 'false' : 'true');
          },
          { threshold: 0 }
        );
        this.observer.observe(this.mainButton);

        this.buy = this.closest('snk-product-buy');
        this.buy?.addEventListener('snk:pair-change', () => this.refresh());
        this.buy?.addEventListener('snk:cart-state', () => this.refresh());
        this.refresh();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      refresh() {
        const info = this.closest('product-info');
        const price = info?.querySelector('.snk-product__amount')?.textContent.trim();
        if (price) this.querySelector('[data-snk-sticky-price]').textContent = price;
        const name = this.dataset.sizeOption;
        // Couleur d'un accessoire (pastilles snk-colour-swatches) : nom traduit de la pastille cochée ; sinon le menu des tailles
        const swatch = info?.querySelector('.snk-swatches input:checked');
        const size = swatch ? swatch.dataset.snkColourLabel : name ? info?.querySelector(`select[name="options[${CSS.escape(name)}]"]`)?.value : '';
        const sizeNode = this.querySelector('[data-snk-sticky-size]');
        // Taille pas encore choisie : on garde « Choisis ta taille »
        if (sizeNode && size && this.buy?.dataset.sizeChosen !== 'false') {
          sizeNode.textContent = size;
          this.querySelector('[data-snk-sticky-size-label]')?.removeAttribute('hidden');
        }
        const soldOut = this.mainButton.disabled;
        this.button.disabled = soldOut;
        // Paire déjà au panier : « Voir le panier », comme le bouton principal
        const view = this.mainButton.hasAttribute('data-snk-view-cart') ? this.mainButton.dataset.viewText : null;
        this.button.textContent = soldOut ? window.variantStrings?.soldOut ?? this.button.textContent : view || (window.variantStrings?.addToCart ?? this.button.textContent);
      }
    }
  );
}
